export { default } from "./Divider"
